var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "mb-2 room-detail card " + (_vm.selected ? "selected" : ""),
      on: { click: _vm.onClick }
    },
    [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("div", [
            _c(
              "p",
              {
                class: _vm.isMobile ? "mb-0 pr-1" : "mb-0",
                style: _vm.isMobile ? "font-size: 0.7rem" : ""
              },
              [_vm._v(_vm._s(_vm.name))]
            ),
            _vm._v(" "),
            _c("small", [_vm._v(_vm._s(_vm.trattamento))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _vm.isMobile
              ? _c("div", { staticClass: "py-1" }, [
                  !_vm.selected
                    ? _c(
                        "h5",
                        {
                          class:
                            _vm.deltaPrice > 0
                              ? "text-danger more currency mr-2 nowrap"
                              : "text-danger minus currency mr-2 nowrap"
                        },
                        [_vm._v(_vm._s(_vm.sign) + _vm._s(_vm.abs) + " €")]
                      )
                    : _c(
                        "h6",
                        { staticClass: "text-right text-uppercase currency" },
                        [_vm._v("selezionato")]
                      )
                ])
              : _c("div", { staticClass: "py-1" }, [
                  !_vm.selected
                    ? _c(
                        "h4",
                        {
                          class:
                            _vm.deltaPrice > 0
                              ? "more currency mr-2"
                              : "minus currency mr-2"
                        },
                        [_vm._v(_vm._s(_vm.sign) + _vm._s(_vm.abs) + " €")]
                      )
                    : _c("h5", { staticClass: "text-right text-uppercase" }, [
                        _vm._v("selezionato")
                      ])
                ]),
            _vm._v(" "),
            _c("div", [
              !_vm.selected
                ? _c("button", {
                    staticClass: "btn btn-outline-primary",
                    on: { click: _vm.onClick }
                  })
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e60f96d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e60f96d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/hotel-panel/RoomDetail.vue
// module id = null
// module chunks = 